import React, { useState, useRef } from 'react';
import Seo from '../components/seo';
import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';
import ProductList from '../components/ProductList';
import classNames from 'classnames';

const Collection = ({ pageContext, location }) => {
  const { collection = {} } = pageContext;

  const {
    hero = {},
    seo = {},
    unfilteredCollection = {},
    filteredCollections = [],
    products = [],
  } = collection;

  const { products: unfilteredProducts = [] } = unfilteredCollection || {};

  const [filteredCollection, setFilteredCollection] = useState(null);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const mobileFiltersRef = useRef(null);

  const collectionProducts =
    products?.length > 0
      ? products
      : filteredCollection
      ? filteredCollection.products
      : unfilteredProducts;

  const metaTitle =
    (seo && seo.metaTitle) || `${collection?.title} | Eugenie Detroit`;
  const openGraphTitle =
    (seo && seo.openGraphTitle) || `${collection?.title} | Eugenie Detroit`;
  const openGraphImage = seo?.openGraphImage || hero?.image;
  const twitterTitle =
    (seo && seo.twitterTitle) || `${collection?.title} | Eugenie Detroit`;
  const twitterImage = seo?.twitterImage || hero?.image;

  return (
    <React.Fragment>
      <Seo
        metaTitle={metaTitle}
        metaDescription={seo?.metaDescription}
        metaKeywords={seo?.metaKeywords}
        openGraphTitle={openGraphTitle}
        openGraphDescription={seo?.openGraphDescription}
        openGraphImage={openGraphImage}
        twitterTitle={twitterTitle}
        twitterDescription={seo?.twitterDescription}
        twitterImage={twitterImage}
        pathname={location.pathname}
      />

      <section className="collection-hero bb--dark-brown df fdc fdr--md">
        <aside className="collection-hero__title p2 pt5--md ">
          <div className="title df mb2 aib">
            <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
              Collection
            </p>
            <h1 className="serif--sm serif--lg--lg">
              {hero?.title || collection?.title}
            </h1>
          </div>
          {hero && hero.description && (
            <div className="desc df mb2 aib">
              <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
                Description
              </p>
              <div className="sans--sm sans--md--lg rich-text">
                <BlockContent
                  blocks={hero.description}
                  serializers={richText}
                />
              </div>
            </div>
          )}
        </aside>
        {hero && hero.image && (
          <section className="bl--dark-brown--lg collection-hero__img">
            <div className="x db image spotlight-index__thumbnail-wrapper">
              <picture className="">
                <source
                  srcSet={`${hero.image.url}?w=1500&auto=format&q=100`}
                  media="(min-width: 1000px)"
                />
                <source
                  srcSet={`${hero.image.url}?w=1000&auto=format`}
                  media="(min-width: 600px)"
                />
                <img
                  alt={hero?.title}
                  className="x"
                  src={`${hero.image.url}?w=600&auto=format`}
                />
              </picture>
            </div>
          </section>
        )}
      </section>

      {filteredCollections && filteredCollections.length > 0 && (
        <React.Fragment>
          <section className="collection__mobile-filters pr hide--lg">
            <button
              onClick={() => setMobileFiltersOpen(!mobileFiltersOpen)}
              className="tl x collection__mobile-filter-trigger bb--dark-brown pl2 pr2"
            >
              Filtered by:{' '}
              {filteredCollection ? (
                <span className="o5">{filteredCollection.title} x</span>
              ) : (
                'All'
              )}
            </button>
            <ul
              ref={mobileFiltersRef}
              className={classNames('collection__mobile-filters-list x pa', {
                open: mobileFiltersOpen,
              })}
            >
              <button
                onClick={() => {
                  setMobileFiltersOpen(false);
                  setFilteredCollection(null);
                }}
                key={collection._key}
                className="sans--sm pl2 x tl collection__mobile-filter bb--dark-brown"
              >
                All
              </button>
              {filteredCollections.map((collection, index) => {
                return (
                  <button
                    onClick={() => {
                      setFilteredCollection(
                        filteredCollection === collection ? null : collection
                      );
                      setMobileFiltersOpen(false);
                    }}
                    key={collection._key}
                    className={classNames(
                      'sans--sm pl2 x tl collection__mobile-filter',
                      {
                        'bt--dark-brown': index > 0,
                        'bb--dark-brown':
                          index === filteredCollections.length - 1,
                      }
                    )}
                  >
                    {collection?.title}
                  </button>
                );
              })}
            </ul>
          </section>
          <section className="collection__filters df bb--dark-brown p1 pl2 psy show--lg">
            <p className="sans--sm mr5--lg show--lg">Filters:</p>
            <button
              onClick={() => setFilteredCollection(null)}
              className={classNames('sans--sm mr2 df aic collection__filter', {
                active: filteredCollection === null,
              })}
            >
              <div className="circle collection__filter-circle mr1" /> All
            </button>
            {filteredCollections.map(collection => {
              return (
                <button
                  onClick={
                    filteredCollection === collection
                      ? () => setFilteredCollection(null)
                      : () => setFilteredCollection(collection)
                  }
                  key={collection._key}
                  className={classNames(
                    'sans--sm mr2 df aic collection__filter',
                    {
                      active:
                        filteredCollection &&
                        filteredCollection.title &&
                        filteredCollection.title === collection?.title,
                    }
                  )}
                >
                  <div className="circle collection__filter-circle mr1" />{' '}
                  {collection?.title}
                </button>
              );
            })}
          </section>
        </React.Fragment>
      )}

      {collectionProducts && (
        <ProductList
          onClick={
            filteredCollection
              ? () => {
                  setFilteredCollection(null);
                }
              : null
          }
          collectionLocation={{
            title: collection?.title,
            slug: location.pathname,
          }}
          products={collectionProducts}
        />
      )}
    </React.Fragment>
  );
};

export default Collection;
